import React from 'react'
export const BaseUrl = "https://carvaanofficial.com/";

export const accessToken =
  typeof window !== "undefined"
    ? localStorage.getItem("accessToken")
    : null;
